import React, { useState } from 'react';

import ModalWrapper from '@components/wrapper/Modal/ModalWrapper';
import Login from './Login';
import SignUp from '../Register/SignUp';
import styled from 'styled-components';
import { useSetRecoilState } from 'recoil';
import { registerOpenState } from '@atom/modal/modal';

const Wrap = styled.div`
  padding: 40px;
`;

function RegisterModal() {
  const [isLoginPage, setIsLoginPage] = useState(true);
  const setOpenModal = useSetRecoilState(registerOpenState);

  const toggleLogin = () => setIsLoginPage(!isLoginPage);

  const handleBack = () => setOpenModal(false);

  return (
    <ModalWrapper outsideClick={handleBack} contentStyle={{ minWidth: 420 }}>
      <Wrap>
        {isLoginPage ? (
          <Login handleGoBack={handleBack} toggleLogin={toggleLogin} />
        ) : (
          <SignUp handleGoBack={handleBack} toggleLogin={toggleLogin} />
        )}
      </Wrap>
    </ModalWrapper>
  );
}

export default RegisterModal;
